import { bera } from "../tokens/bera";

export default {
  name: "Kodiak",
  icon: "/images/dapps/kodiak.svg",
  path: "/dex/kodiak",
  defaultInputCurrency: bera["bera"],
  tokens: {
    80094: [
      bera["bera"],
      bera["wbera"],
      bera["weth"],
      bera["usdc.e"],
      bera["honey"],
      bera["wbtc"],
      bera["usdt0"],
      bera["bonga"],
      bera["yeet"],
      bera["ramen"],
      bera["bblast"],
      bera["bm"],
      bera["hold"],
      bera["henlo"]
    ]
  }
};
